export default {
  // 3-14
  GET_LICENSEFORM_INFO(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    state.license_type = data.types;
    state.license_people = data.people;
  },
};
